import { TriangleAlert } from 'lucide-react';
import { isModuleNotFoundError } from '@tanstack/router-core';
import { DefaultLoader } from './DefaultLoader';

const ErrorComponent = ({ error }: { error: Error }) => {
    const message =
        error.message.length > 240
            ? `${error.message.slice(0, 240)}...`
            : error.message;

    return (
        <div className="gap-2 flex flex-col h-full items-center justify-center">
            <div className="flex gap-2 w-full self-center items-center justify-center m-auto flex-row">
                <TriangleAlert className="text-primary" size={48} />
                <div className="border-l-2 border-secondary-light px-2">
                    <p className="text-xl text-secondary-light">
                        An error occured:
                    </p>
                    <p
                        className="text-2xl text-secondary-foreground"
                        title={error.message}
                    >
                        {message}
                    </p>
                </div>
            </div>
        </div>
    );
};

export const DefaultError = ({ error }: { error: Error }) => {
    if (isModuleNotFoundError(error)) {
        return <DefaultLoader />;
    }
    return (
        <div className="bg-background-dark w-full min-h-[calc(100vh-150px)] p-4 rounded-2xl flex flex-col items-center justify-center">
            <ErrorComponent error={error} />
        </div>
    );
};
